__turbopack_context__.v({
  "aboutMe": "-jRFpq_aboutMe",
  "addresses": "-jRFpq_addresses",
  "black": "-jRFpq_black",
  "bottom": "-jRFpq_bottom",
  "companyImage": "-jRFpq_companyImage",
  "container": "-jRFpq_container",
  "dark": "-jRFpq_dark",
  "description": "-jRFpq_description",
  "divider": "-jRFpq_divider",
  "download": "-jRFpq_download",
  "field": "-jRFpq_field",
  "fileList": "-jRFpq_fileList",
  "fileWrapper": "-jRFpq_fileWrapper",
  "filesInfo": "-jRFpq_filesInfo",
  "flex": "-jRFpq_flex",
  "flexedFields": "-jRFpq_flexedFields",
  "form": "-jRFpq_form",
  "formWrapper": "-jRFpq_formWrapper",
  "fullWidth": "-jRFpq_fullWidth",
  "headerWithIcon": "-jRFpq_headerWithIcon",
  "headingSection": "-jRFpq_headingSection",
  "info": "-jRFpq_info",
  "infoSection": "-jRFpq_infoSection",
  "informationDownload": "-jRFpq_informationDownload",
  "isDanger": "-jRFpq_isDanger",
  "leftContent": "-jRFpq_leftContent",
  "light": "-jRFpq_light",
  "main": "-jRFpq_main",
  "mainInfo": "-jRFpq_mainInfo",
  "mobileCompanyImage": "-jRFpq_mobileCompanyImage",
  "mobileContent": "-jRFpq_mobileContent",
  "previewImage": "-jRFpq_previewImage",
  "profileImage": "-jRFpq_profileImage",
  "profileWrapper": "-jRFpq_profileWrapper",
  "rightContent": "-jRFpq_rightContent",
  "socialIcon": "-jRFpq_socialIcon",
  "socials": "-jRFpq_socials",
  "stayConnected": "-jRFpq_stayConnected",
  "submitWrapper": "-jRFpq_submitWrapper",
  "title": "-jRFpq_title",
  "userDescription": "-jRFpq_userDescription",
  "userInfo": "-jRFpq_userInfo",
  "userWrapper": "-jRFpq_userWrapper",
  "webpage": "-jRFpq_webpage",
  "white": "-jRFpq_white",
  "withCheckbox": "-jRFpq_withCheckbox",
  "withSeparator": "-jRFpq_withSeparator",
});
